export enum SchoolMetricCategory {
    enrolled = 'enrolled',
    avgCourseTime = 'avgCourseTime',
    assignmentsActive = 'assignmentsActive',
    assignmentsPastDue = 'assignmentsPastDue',
    acsTestPassRate = 'acsTestPassRate',
    awaitingACSTestUpload = 'awaitingACSTestUpload'
}